

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice
const name = "MyProfile";
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({
    name,
    initialState,
    extraReducers: (builder) => {
        createExtraReducers(builder, extraActions);
    },
});

export const MyProfileSecurityQuestionsActions = { ...slice.actions, ...extraActions };
export const MyProfileSecurityQuestionsActionsReducer = slice.reducer;

// Function to create the initial state
function createInitialState() {
    return {
        questions: [],
        updateInmateSecurityQuestion: [],
    };
}

// Function to create extra actions
function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}`;

    return {
        getInmateSecurityQuestions: getInmateSecurityQuestions(),
        updateInmateSecurityQuestion: updateInmateSecurityQuestion(),
    };

    function getInmateSecurityQuestions() {
        return createAsyncThunk(
            `${name}/getInmateSecurityQuestions`,
            async ({ inmateId, facilityId }) =>
                await fetchWrapper.get(`${baseUrl}/Kiosk/KioskLogin/GetLoadInmateSecurityQuestionSet?inmateId=${inmateId}&facilityID=${facilityId}`)
        );
    }
    function updateInmateSecurityQuestion() {
        return createAsyncThunk(
            `${name}/InmateKioskSecurityQuestionInsertUpdate`,
            async (updatedQuestions) => {
                const response = await fetchWrapper.post(`${baseUrl}/Kiosk/KioskLogin/InmateKioskSecurityQuestionInsertUpdate`, updatedQuestions);
                return response; // Return the response data
            }
        );
    }
}

// Function to create extra reducers
function createExtraReducers(builder, actions) {
    const { getInmateSecurityQuestions } = actions;
    const { updateInmateSecurityQuestion } = actions;
    builder
        .addCase(getInmateSecurityQuestions.pending, (state) => {
            state.questions = [];
        })
        .addCase(getInmateSecurityQuestions.fulfilled, (state, action) => {
            state.loading = false;
            state.questions = action.payload; // Store the fetched questions
        })
        .addCase(getInmateSecurityQuestions.rejected, (state, action) => {
            state.loading = false;
            state.questions = { error: action.error }; // Handle the error
        })
        .addCase(updateInmateSecurityQuestion.pending, (state) => {
            state.updateInmateSecurityQuestion = []; // Set loading to true when updating
            state.error = null; // Reset error
        })
        .addCase(updateInmateSecurityQuestion.fulfilled, (state, action) => {
            state.updateInmateSecurityQuestion = action.payload;
        })
        .addCase(updateInmateSecurityQuestion.rejected, (state, action) => {
            state.updateInmateSecurityQuestion = { error: action.error };
        });
}



